<template>
    <div id="app">
        <router-view />
        <depositPopup></depositPopup>
        <withdrawPopup></withdrawPopup>
        <bankSet></bankSet>
        <withdrawPwdSetPopup></withdrawPwdSetPopup>
        <loadingPopup></loadingPopup>
    </div>
</template>
<script>
import { getSysBaseConfig, telegramLogin } from '@/api/system'
import { getUserInfo } from '@/api/user'
// import { domain } from '@/common/http'
import { getPWAValue } from '@/api/pwa'
import { isPWA, getPlatform } from '@/utils'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
export default {
    created() {
        this.$i18n.locale = this.$store.getters.language
        const equipmentId = this.$store.state.system.equipmentId
        if (!equipmentId) this.getBrowserFingerprint()
    },
    mounted() {
        const that = this

        // 设置根据屏幕高度缩放
        document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px')

        if (!this.$store.getters.invitCode && getPlatform() === 'ios' && isPWA()) this.getPWAValue()

        getSysBaseConfig().then((res) => {
            if (res.code) return
            const D = res.result
            this.$store.dispatch('system/setSysConfig', D)
            if (D.belongCountry && (!this.$store.state.system.userSetlanguage)) {
                this.$store.dispatch('system/setLanguage', D.belongCountry)
                this.$i18n.locale = D.belongCountry
            }
            try {
                const link = document.querySelector("link[rel*='icon']")
                if (link) link.href = D.homeImageUrl
                // document.querySelector('meta[property="og:title"]').setAttribute('content', D.projectName)
                // document.querySelector('meta[property="og:url"]').setAttribute('content', domain)
                // document.querySelector('meta[property="og:image"]').setAttribute('content', D.homeLogoUrl)
                // document.querySelector('meta[property="og:description"]').setAttribute('content', D.projectName)
            } catch (e) {
                console.log(e)
            }
        })
        try {
            const token = this.$store.getters.token
            if (token) {
                getUserInfo().then((uInfo) => {
                    if (uInfo.code) return
                    that.$websocket.initWebSocket()
                })
            } else {
                this.$websocket.close()
            }
        } catch (e) {
            console.log(e)
        }
        try {
            let isInstallPWA = 2
            if ('serviceWorker' in navigator) {
                window.addEventListener('beforeinstallprompt', function (e) {
                    // 阻止默认提示弹出
                    e.preventDefault()
                    that.$store.dispatch('system/setIsShowDownAppNav', 1)
                    that.$store.dispatch('system/setIsSaveVersionDesktop', 1)
                    isInstallPWA = 1
                    // console.log('PWA未安装555555')
                })
                if (isInstallPWA === 2) {
                    // console.log('PWA已经安装666666')
                    if (getPlatform() === 'ios') return
                    that.$store.dispatch('system/setIsShowDownAppNav', 2)
                    that.$store.dispatch('system/setIsSaveVersionDesktop', 2)
                }
            } else {
                // console.log('Service Worker 不受此浏览器支持')
                // that.$store.dispatch('system/setIsShowDownAppNav', 1)
                that.$store.dispatch('system/setIsSaveVersionDesktop', 2)
            }
        } catch (e) {
            console.log(e, 'PWA错误')
        }
        window.addEventListener('beforeunload', this.handleBeforeUnload)

        that.telegramLogin()
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload)
    },
    methods: {
        handleBeforeUnload(event) {
            this.$websocket.close()
            console.log('浏览器即将关闭', event)
        },
        getPWAValue() {
            const that = this
            const userAgent = navigator.userAgent
            const params = { userAgent }
            getPWAValue(params).then((res) => {
                if (res.code) return
                const D = res.result
                that.$store.dispatch('user/setInvitCode', D.invitationCode)
                that.$store.dispatch('system/setPixel', D.trafficAcquisitionType)
                that.$store.dispatch('system/setTaId', D.taid)
                that.$store.dispatch('system/setClickId', D.clickId)
                that.$store.dispatch('user/setInvitCodeNum', 1)
                if (that.$store?.getters.invitCode && (!that.$store?.getters.token) && that.$store?.getters.invitCodeNum === 1) {
                    console.log(66666)
                    that.$store.dispatch('user/setInvitCodeNum', 2)
                    that.$store.dispatch('user/changeLoginType', 1)
                    that.$store.dispatch('user/setIsShowLoginPopup', true)
                }
            })
        },
        telegramLogin() {
            const WebApp = window.Telegram.WebApp
            WebApp.ready()
            const user = WebApp.initDataUnsafe.user
            if (user) {
                this.$store.commit('user/SET_TOKEN', '')
                const initData = WebApp.initData
                const params = JSON.stringify({ initData: initData })
                telegramLogin(params).then((res) => {
                    if (res?.code === 0) {
                        this.$store.dispatch('user/setInvitCode', '')
                        this.$store.dispatch('system/setTelegramUserId', '')
                        this.$store.commit('user/SET_TOKEN', `${res.result.tokenHead} ${res.result.token}`)
                        this.$forceUpdate()
                        getUserInfo().then((uInfo) => {
                            if (uInfo.code) return
                            this.$websocket.initWebSocket()
                        })
                        this.$store.dispatch('user/setIsShowLoginPopup', false)
                    }
                    if (res?.code === 401) {
                        this.$store.dispatch('system/setTelegramUserId', res.result.telegramUserId)
                    }
                })
            }
        },
        async getBrowserFingerprint() {
            let browserFinger
            try {
                const fp = await FingerprintJS.load()
                const result = await fp.get()
                browserFinger = result.visitorId
            } catch (error) {
                browserFinger = 'default123456789'
            }
            this.$store.dispatch('system/setEquipmentId', browserFinger)
        }
    }
}
</script>
<style lang="scss">
@media screen and (min-width: 650px) {
    #app:not(.full-screen) {
        min-height: calc(var(--vh, 1vh) * 100 - .8rem);
        width: calc(var(--vh, 1vh) * 100 * 750 / 1334) !important;
        box-sizing: content-box;
        left: 50%;
        transform: translate(-50%, -50%);
        margin: 0 auto;
        position: fixed;
        top: 50%;
    }
}
#app {
    // font-family: "Inter", -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, "Segoe UI", Arial, Roboto, "PingFang SC", miui, "Hiragino Sans GB", "Microsoft Yahei", sans-serif;
    // -webkit-font-smoothing: antialiased;
    font-family: -apple-system, BlinkMacSystemFont, HInter, Helvetica Neue, Helvetica, Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB, Microsoft Yahei, sans-serif;
    -webkit-font-smoothing: antialiased;
    text-align: center;
    --theme-page-bg: linear-gradient(180deg, #111111 0%, #0c0c0c 38%, #080808 100%);
    --theme-page-bg-size: cover;
    --theme-page-bg-position: center top;
    color: #fff4eb;
    position: relative;
    background-color: #0b0907;
    background-image: var(--theme-page-bg);
    background-size: var(--theme-page-bg-size);
    background-position: var(--theme-page-bg-position);
    overflow: hidden;
    height: 100vh;
    // background-image:
    //     linear-gradient(180deg, rgba(4, 18, 40, .12) 0%, rgba(4, 18, 40, .28) 100%),
    //     linear-gradient(90deg, rgba(21, 96, 170, .1) 0%, rgba(21, 96, 170, 0) 30%, rgba(4, 18, 40, .14) 100%),
    //     url("~@/assets/home/bg.png");
    // background-size: cover, cover, cover;
    // background-position: center top, center top, center top;
    // background-repeat: no-repeat, no-repeat, no-repeat;
}
#app:after {
    content: "";
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    right: 0;
    z-index: -1;
    opacity: .6;
    background: url(@/assets/common/appbg.png) repeat center / 2.5rem 2.5rem;
}

html[data-device-nodesktop="0"] {
    body {
        ::-webkit-scrollbar {
            display: none;
        }
    }
}

.global-toast {
    background: #21170f !important;
    border-radius: 12px !important;
    padding: 16px 24px !important;
    color: #ffffff !important;
}
.global-toast .van-toast__text {
    color: #fff !important;
    font-size: .26rem !important;
}

body {
    margin: 0 !important;
    background-color: #0b0907 !important;
    // background-image:
    //     linear-gradient(180deg, rgba(4, 18, 40, .12) 0%, rgba(4, 18, 40, .28) 100%),
    //     linear-gradient(90deg, rgba(21, 96, 170, .1) 0%, rgba(21, 96, 170, 0) 30%, rgba(4, 18, 40, .14) 100%),
    //     url("~@/assets/home/bg.png");
    // background-size: cover, cover, cover;
    // background-position: center top, center top, center top;
    // background-repeat: no-repeat, no-repeat, no-repeat;
    // background-attachment: fixed;

    ::-webkit-scrollbar {
        width: .08rem;
        height: .06rem;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: .5rem;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background-color: #8c5a36;
        // border: .05rem solid #0A0A0A;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
        border-radius: 5px;
        background-color: transparent;
    }

    .ant-input-affix-wrapper {
        width: 100%;
        height: 100%;
        border: none !important;
        background-color: transparent !important;
        color: #fff !important;

        // &:hover {
        //     .ant-input:not(.ant-input-disabled) {
        //         background-color: transparent !important;
        //         border: none !important;
        //     }
        // }

        // .ant-input:hover {
        //     background-color: transparent !important;
        //     border: none !important;
        // }

        .ant-input:focus {
            background-color: transparent !important;
            border: none !important;
            box-shadow: none;
        }

        .ant-input:active {
            background-color: transparent !important;
            border: none !important;
        }

        .ant-input {
            width: 100%;
            height: 100%;
            border: none;
            background-color: transparent !important;
            color: #fff4eb !important;
        }

        .ant-input-suffix {
            right: 0 !important;

            .ant-input-clear-icon {
                font-size: .29rem;
                color: #ff9b2f;
            }
        }
    }
}
</style>
